import schema, { generateType, } from './Schema';
export const Question = generateType(schema.getModel('question'));
export const Questionnaire = generateType(schema.getModel('questionnaire')).actions((self) => ({
    recordResponse: (question, response) => {
        const newQuestions = [...self.questions];
        const index = self.questions.indexOf(question);
        const newQuestion = { ...question, response };
        if (index === -1) {
            newQuestions.push(newQuestion);
        }
        else {
            newQuestions[index] = newQuestion;
        }
        self.questions = newQuestions;
    },
}));
//# sourceMappingURL=QuestionnaireModel.js.map